import { DevEnvBanner as EnvKitBanner } from 'env-kit/client/index.js';
import { useT } from '../../i18n';

/* The env-kit dev banner (DEPLOY_ENV=dev), with PMO's translations. Rendered at
   the app root so it also shows on the login page; nothing on prod. */
export function DevEnvBanner() {
  const { t } = useT();
  return <EnvKitBanner labels={{ label: t('shell.devBanner.label'), text: t('shell.devBanner.text') }} />;
}
